import React from 'react';
import { Slider, TextField, Tooltip } from '@mui/material';
import { BsQuestionCircle } from 'react-icons/bs';

const FinalSoc: React.FC<{
  socLimit: number;
  setSocLimit: (newSocLimit: number) => void;
  disabled: boolean;
}> = ({ socLimit, setSocLimit, disabled }) => {
  return (
    <>
      <div className="d-flex align-items-center w-100 mb-3" style={{ gap: '8px' }}>
        <h4 className="m-0">Cargar hasta</h4>
        <Tooltip
          disableInteractive
          placement="top"
          title='Para guardar el SoC máximo de carga, selecciona el valor que necesites y haz click en el botón "Actualizar SoC Máximo" antes de que se inicie la carga. Esto es útil para cuando una carga se realiza de forma automática al conectar el vehículo.'
        >
          <div>
            <BsQuestionCircle />
          </div>
        </Tooltip>
      </div>
      <div className="d-flex align-items-center justify-content-center slider-container mb-3">
        <Slider
          disabled={disabled}
          className="mr-3"
          value={socLimit}
          onChange={(_event, newValue) => setSocLimit(newValue as number)}
        />
        <TextField
          disabled={disabled}
          label="Limit charge"
          type="number"
          value={socLimit}
          size="small"
          className="text-center hide-label"
          variant="outlined"
          onChange={(event) => setSocLimit(parseInt(event.target.value))}
          InputLabelProps={{
            shrink: false,
          }}
          hiddenLabel={true}
        />
      </div>
    </>
  );
};
export default FinalSoc;
